import { API_BASE, API_KEY } from 'gatsby-env-variables'

import { storage } from '@itau-loans-www/utils'
import axios from 'axios'

import { onResponseSuccess, onResponseError } from './interceptors'

const _http = axios.create({
  baseURL: API_BASE
})

_http.interceptors.response.use(onResponseSuccess, onResponseError)

const getAuth = () => {
  return storage.session.getItem('token')
}

const authorization = async () => {
  const request = _http.get(`v2/authorization/`)

  const { data } = await request

  return data
}

const refreshAuthorization = async () => {
  const request = _http.get(`v2/authorization/new`)

  const { data } = await request

  return data
}

const auth = async ({ auth = true }) => {
  const authData = getAuth()

  if (auth) {
    _http.defaults.headers.common['app'] = API_KEY

    if (authData?.accessToken) {
      _http.defaults.headers.common['token'] = `Bearer ${authData?.accessToken}`

      const now = Math.floor(Date.now() / 1000)

      const diff = authData?.validTime - now

      if (diff < 300) {
        //300 is 5 minutes in unix timestamp
        const refreshToken = await refreshAuthorization()

        const refreshedToken = {
          ...authData,
          accessToken: refreshToken?.token,
          startDate: refreshToken?.server_time,
          validTime: refreshToken?.valid_time
        }

        storage.session.setItem('token', JSON.stringify(refreshedToken))

        _http.defaults.headers.common['token'] = `Bearer ${refreshToken?.token}`
      }
    } else {
      const authRequest = await authorization()

      const token = {
        accessToken: authRequest?.token,
        startDate: authRequest?.server_time,
        validTime: authRequest?.valid_time
      }

      storage.session.setItem('token', JSON.stringify(token))

      _http.defaults.headers.common['token'] = `Bearer ${authRequest?.token}`
    }
  }

  return Promise.resolve(_http)
}

export default auth
